import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TravelDetailsItem } from '@models/shopping-cart.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-travel-details-readonly',
  templateUrl: './travel-details-readonly.component.html',
  imports: [CommonModule, TranslationPipe]
})
export class TravelDetailsReadonlyComponent {
  @Input() travel_details: TravelDetailsItem[];
}
